export enum ToolStatus {
  Available = 'available',
  Borrowed = 'borrowed',
  Missing = 'missing',
}
